import axios from 'axios';

function getQueryParam(name) {
    var match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
}

function normalizeGender(value) {
    return (value === 'man' || value === 'woman') ? value : '';
}

export default {
  state: {
    gender: normalizeGender(getQueryParam('gender')),
    loading: false,
    genderError: null,
    genderLoaded: false
  },
  mutations: {
    SET_GENDER(state, gender) {
      state.gender = gender;
      state.genderLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_GENDER_LOADING(state, status) {
      state.genderLoading = status;
    },
    UNSET_GENDER(state) {
      state.genderLoaded = false;
      state.genderLoading = false;
      state.gender = '';
    },
    SET_GENDER_ERROR(state, error) {
      state.genderError = error;
    }
  },
  actions: {
    async fetchGender({ commit, state }) {

      if (state.gender)
        return;

      try {
        commit('SET_GENDER_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/gender/');
        if (response.data.status != 'error') {
          commit('SET_GENDER', response.data.data);
          commit('SET_GENDER_ERROR', null);
        }
        else
          commit('SET_GENDER_ERROR', response.data.errors[0]['message']);
      } catch (error) {
        commit('SET_GENDER_ERROR', error.message || 'Ошибка при загрузке');
        console.error('Error fetching gender:', error);
      } finally {
        commit('SET_GENDER_LOADING', false);
      }
    },
    async setGender({ commit, state }, gender) {
      try {
        commit('SET_GENDER_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/gender/', {
          gender: gender
        },{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response.data.status != 'error') {
          commit('SET_GENDER', response.data.data);
          commit('SET_GENDER_ERROR', null);
        }
        else
          commit('SET_GENDER_ERROR', response.data.errors[0]['message']);
      } catch (error) {
        commit('SET_GENDER_ERROR', error.message || 'Ошибка при загрузке');
        console.error('Error fetching gender:', error);
      } finally {
        commit('SET_GENDER_LOADING', false);
      }
    }
  },
  getters: {
    gender: state => state.gender,
    genderLoading: state => state.genderLoading,
    genderError: state => state.genderError,
    genderLoaded: state => state.genderLoaded
  }
}